module.exports = __webpack_public_path__ + "static/media/community.f9941280.jpg";